import React from 'react';

import gerda from '../audio/gerda.mp3';

import InternalPage from '../components/InternalPage';
import Hint from '../components/Hint';
import Peek from '../components/Peek';
import Blur from '../components/Blur';

import internalPageStyle from '../components/InternalPage/layout.module.css';

import GerdaHidden from '../images/Gerda-hidden.jpg';
import GerdaOver from '../images/Gerda-over.png';
import GerdaBlur from '../images/Gerda-blur.jpg';
import GerdaBlurOver from '../images/Gerda-blur-over.jpg';

const GerdaPage = () => (
  <InternalPage
    next="/ruslan"
    name="Герда"
    bio="Редактор, 35 лет"
    audio={gerda}
    audioDuration={212}
  >
    <div className={internalPageStyle.titleContainer}>
      <h2 className={internalPageStyle.title}>
        КАЗАЛОСЬ, СЕКС&nbsp;&mdash; ЭТО <br />
        ЧТО-ТО СТРАШНОЕ
      </h2>
      <div className={internalPageStyle.topImage}>
        <Blur image={GerdaBlur} imageBlur={GerdaBlurOver} />
      </div>
    </div>

    <div className={internalPageStyle.textContainer}>
      <div className={internalPageStyle.text}>
        В&nbsp;детстве я&nbsp;как-то раз случайно нашла у&nbsp;папы газету
        &laquo;Адская почта&raquo;. По&nbsp;сравнению с&nbsp;ней
        &laquo;СПИД-инфо&raquo;&nbsp;&mdash; детский лепет, там описывалось всё
        по&nbsp;полной программе и&nbsp;нужными словами. Первое порно
        я&nbsp;посмотрела в&nbsp;14, мы&nbsp;с&nbsp;подружкой нашли
        у&nbsp;её&nbsp;отчима кассету с&nbsp;фильмом &laquo;Красная
        Шапочка&raquo;&nbsp;&mdash; там всё сразу показали лицом, включая,
        кажется, даже&nbsp;
        <Hint definition="Копро&nbsp;&mdash; форма сексуального поведения, при котором половое возбуждение и&nbsp;удовлетворение достигается в&nbsp;ходе манипуляций с&nbsp;калом партнёра.">
          копро
        </Hint>
        .
      </div>

      <div className={internalPageStyle.text}>
        Комп с&nbsp;интернетом в&nbsp;нашей семье появился, когда мне
        было&nbsp;17, и&nbsp;стоял он&nbsp;в&nbsp;проходной комнате. Однажды
        ночью несколькими годами позже мама застала меня за&nbsp;просмотром
        в&nbsp;наушниках какого-то{' '}
        <Hint definition="BDSM&nbsp;&mdash; сексуальные практики, основанные на&nbsp;обмене властью и&nbsp;связанные с&nbsp;лишением подвижности, причинением боли и&nbsp;унижением.">
          BDSM
        </Hint>
        -ного ролика, погладила по&nbsp;голове и&nbsp;пошла дальше. Надо знать
        мою маму, которая вообще-то дикий пуританин, ей&nbsp;было сложно принять
        мою сексуальность, ей&nbsp;казалось, что секс&nbsp;&mdash; это что-то
        такое страшное, от&nbsp;чего нужно оберегать девочку. Она, конечно,
        транслировала мне свои страхи, но&nbsp;поток был настолько мощным, что
        ничего не&nbsp;помогло. Секс в&nbsp;частности и&nbsp;вообще тактильность
        (объятия, поглаживания)&nbsp;&mdash; это для меня всё, я&nbsp;человек
        нервный, и, если хотя&nbsp;бы раз в&nbsp;неделю не&nbsp;происходит
        качественного контакта, чувствую себя плохо морально и&nbsp;физически.
      </div>

      <p className={internalPageStyle.quote}>
        Когда мне было&nbsp;20, я&nbsp;встретила самого большого извращенца
        в&nbsp;своей жизни.
      </p>

      <div className={internalPageStyle.text}>
        Фантазии про BDSM стали реализовываться на&nbsp;практике. Сам
        он&nbsp;был{' '}
        <Hint definition="Кросс-дрессер&nbsp;&mdash; мужчина, который любит одеваться в&nbsp;женскую одежду (явно или тайно).">
          кросс-дрессером
        </Hint>
        , показывал мне гей-порно, увлекался женщинами с&nbsp;нестандартной
        внешностью и&nbsp;трансвеститами. Это вызывало любопытство,
        но&nbsp;на&nbsp;практике я&nbsp;предпочитала классическое порно, лучше
        групповое или с&nbsp;элементами доминирования.
      </div>

      <p className={internalPageStyle.text}>
        Примерно в&nbsp;27&nbsp;лет в&nbsp;мою жизнь пришёл осознанный феминизм,
        и&nbsp;я&nbsp;поняла, что большинство порнофильмов я&nbsp;больше
        смотреть не&nbsp;могу, поскольку там всё завязано на&nbsp;мужской
        грубости и&nbsp;овеществлении, унижении, циничном использовании женского
        тела. Есть актрисы вроде Саши Грей, которым искренне нравится
        происходящее, но&nbsp;я&nbsp;сильно сомневаюсь, что таких очень много.
        Эмоции с&nbsp;экрана льются неприятные, хочется зажаться, скривиться,
        закрыться. Доминирование&nbsp;&mdash; это нормально,
        но&nbsp;не&nbsp;нужно подчёркнуто делать нормой презрительность (все эти
        пихания трёх членов в&nbsp;одну жопу и&nbsp;выворачивания влагалища
        наизнанку).
      </p>

      <div className={internalPageStyle.middleImage}>
        <Peek
          hiddenImage={GerdaHidden}
          overImage={GerdaOver}

          limitX={50}
          limitY={50}

          scale={1.1}

          scaleOver={1.1}
        />
      </div>

      <p className={internalPageStyle.text}>
        В&nbsp;последнее время несколько раз попадались фильмы, изображающие
        секс в&nbsp;его более жизненном виде: с&nbsp;прелюдией,
        равноуважительным отношением партнёров и&nbsp;любованием друг другом.
        Несмотря на&nbsp;мою любовь к&nbsp;BDSM, такое порно лично меня
        возбуждает гораздо больше.
      </p>

      <p className={internalPageStyle.text}>
        Сейчас у&nbsp;меня не&nbsp;осталось никаких нереализованных желаний
        и&nbsp;блоков. Для меня понятия нормы не&nbsp;существует,
        норма&nbsp;&mdash; это всё, что не&nbsp;причиняет вреда другим, всё, что
        добровольно с&nbsp;двух сторон. Думаю, порно повлияло на&nbsp;моё
        развитие в&nbsp;сексуальном плане, но, если&nbsp;бы его
        и&nbsp;не&nbsp;было, дошла&nbsp;бы до&nbsp;всего сама.
      </p>
    </div>
  </InternalPage>
);

export default GerdaPage;
